//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import MyBtnReturn from '@/components/subComponents/MyBtnReturn'

export default {
    name: "Vehicletracking",
    components: {
        MyBtnReturn
    },
    data() {
        return {
            loadDate: '',
            unloadingDate: '',
            truck_no: '',
            is_self: null, // 这个就是类型
            is_selfOps: [
                {
                    key: '自有车',
                    value: '自有车'
                },
                {
                    key: '挂靠车',
                    value: '挂靠车'
                },
                {
                    key: '临时车',
                    value: '临时车'
                },
            ],

        }
    },
    created() {
        document.title = '车辆跟踪'
    },
    methods: {
        search() {
            this.$router.push({
                name: 'VehicletrackingResult',
                query: {
                    begin: this.loadDate || '',
                    end: this.unloadingDate || '',
                    truck_no: this.truck_no || '',
                    is_self: this.is_self || '',
                }
            })
        },
    }
}



// WEBPACK FOOTER //
// ./src/components/yewu/vehicletracking/Vehicletracking.vue